export default __webpack_public_path__ + "static/media/logo-small.981ccda3.png";